/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ComponentGroup } from '../../models/component-group';
import { ComponentGroupInput } from '../../models/component-group-input';

export interface CatalogEntriesComponentGroupsCatalogEntryIdPut$Params {
  'Active-Tenant-Identifier': string;
  catalogEntryId: string;
      body: ComponentGroupInput
}

export function catalogEntriesComponentGroupsCatalogEntryIdPut(http: HttpClient, rootUrl: string, params: CatalogEntriesComponentGroupsCatalogEntryIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<ComponentGroup>> {
  const rb = new RequestBuilder(rootUrl, catalogEntriesComponentGroupsCatalogEntryIdPut.PATH, 'put');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('catalogEntryId', params.catalogEntryId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ComponentGroup>;
    })
  );
}

catalogEntriesComponentGroupsCatalogEntryIdPut.PATH = '/catalog-entries/component-groups/{catalogEntryId}';
